export default "__VITE_ASSET__BlQKsSJa__"